import React from 'react'
import { useSurvey } from '../../contexts/SurveyProvider'
import { useTURF } from '../../contexts/TURFProvider'
import { useMaxDiff } from '../../contexts/MaxDiffProvider'

const percentageFormatter = new Intl.NumberFormat('en', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

export default function TURFTotals() {
  const { maxDiffShowFavorites } = useMaxDiff()
  const { totals, loading } = useTURF()
  const { weights } = useSurvey()

  if (totals === undefined) {
    return null
  }

  return (
    <div className={`turf-totals ${loading ? 'turf-totals-loading' : ''}`}>
      <span className="turf-totals-item">
        <span className="turf-totals-label">Reach</span>
        <span className={`turf-totals-value ${totals.reach >= 1 ? 'highlighted' : ''}`}>
          {percentageFormatter.format(totals.reach)}
        </span>
      </span>
      <span className="turf-totals-sep" />
      <span className="turf-totals-item">
        <span className="turf-totals-label">Liked</span>
        <span className="turf-totals-value">{totals.liked.toFixed(1)}</span>
      </span>
      {maxDiffShowFavorites && (
        <>
          <span className="turf-totals-sep" />
          <span className="turf-totals-item">
            <span className="turf-totals-label">Favorites</span>
            <span className="turf-totals-value">
              {percentageFormatter.format(totals.favourite)}
            </span>
          </span>
        </>
      )}
      <span className="turf-totals-sep" />
      <span className="turf-totals-item">
        <span className="turf-totals-label">
          Respondents{weights && ' (weighted)'}
        </span>
        <span className="turf-totals-value">
          {Math.round(totals.respondentsReached)} / {Math.round(totals.respondentsTotal)}
        </span>
      </span>
    </div>
  )
}
